import { MonthWaterOverviewInfo } from '~/providers/types/api-private';

export const DISABLED_DATA_INFO: MonthWaterOverviewInfo = {
  TYPE: 'month',
  HISTORY: [
    {
      MONTH: 1,
      USAGE: 10000,
      YEAR: 2025,
    },
    {
      MONTH: 2,
      USAGE: 10000,
      YEAR: 2025,
    },
    {
      MONTH: 3,
      USAGE: 10000,
      YEAR: 2025,
    },
    {
      MONTH: 4,
      USAGE: 10000,
      YEAR: 2025,
    },
    {
      MONTH: 5,
      USAGE: 10000,
      YEAR: 2025,
    },
    {
      MONTH: 6,
      USAGE: 10000,
      YEAR: 2025,
    },
    {
      MONTH: 7,
      USAGE: 10000,
      YEAR: 2025,
    },
  ],
  TOTAL: 0,
};
